import React from 'react'

import EtcPage from 'Components/EtcPage/EtcPage'

export default function Parent() {
  return <EtcPage content="부모님 페이지입니다." />
}
